import ItiTabsComponent from "@/iti-core-react/components/ItiTabs/ItiTabs";
import { useLanguage } from "@/iti-core-react/hooks/useLanguage";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./Recycle.scss";
import RecycleDatasetList from "./RecycleDataset/RecycleDatasetList/RecycleDatasetList";
import RecycleGlossaryList from "./RecycleGlossaryList/RecycleGlossaryList";

export default function Recycle() {
	const { t } = useLanguage();
	const location = useLocation();
	const navigate = useNavigate();
	const { tab } = useParams<{ tab?: string }>();
	const [tabIndex, setTabIndex] = useState<number>(0);

	const tabPanelItems = [
		{
			title: t("recycle.datasets"),
			key: "datasets",
			content: <RecycleDatasetList />,
		},
		{
			title: t("recycle.glossaries"),
			key: "glossaries",
			content: <RecycleGlossaryList />,
		},
		// Comentamos estas tabs por el momento hasta nuevo aviso
		// {
		// 	title: t("recycle.requests"),
		// 	key: "solicitudes",
		// 	content: <RecycleDeletionRequestsList />,
		// },
		// {
		// 	title: t("recycle.organizations"),
		// 	key: "organizations",
		// 	content: <RecycleOrganizationList />,
		// },
		// {
		// 	title: t("recycle.departments"),
		// 	key: "departments",
		// 	content: (
		// 		<div>
		// 			<RecycleDepartmentList />
		// 		</div>
		// 	),
		// },
		// {
		// 	title: t("recycle.users"),
		// 	key: "users",
		// 	content: <RecycleUsersList />,
		// },
	];

	useEffect(() => {
		// Prioridad 1: Parámetro de ruta (/recycle-bin/datasets)
		if (tab) {
			const targetTabIndex = tabPanelItems.findIndex(
				(tabItem) => tabItem.key === tab,
			);

			if (targetTabIndex !== -1) {
				setTabIndex(targetTabIndex);
				return;
			}
		}

		// Prioridad 2: Estado de navegación (compatibilidad con código existente)
		if (location.state?.tab) {
			const targetTabIndex = tabPanelItems.findIndex(
				(tabItem) => tabItem.key === location.state.tab,
			);

			if (targetTabIndex !== -1) {
				setTabIndex(targetTabIndex);
				return;
			}
		}

		// Por defecto: primera tab (datasets)
		setTabIndex(0);
	}, [tab, location.state, tabPanelItems]);

	const onSelectedIndexChange = (index: number) => {
		setTabIndex(index);

		// Navegar a la nueva ruta con el parámetro de tab
		const selectedTab = tabPanelItems[index];
		if (selectedTab) {
			// Usar navigate con replace para mantener la misma entrada en el historial
			navigate(`/recycle-bin/${selectedTab.key}`, { replace: true });
		}
	};

	return (
		<>
			<div className="content-block">
				<div className="row">
					<div className="col-12 d-flex">
						<i className={"mdi mdi-delete-empty icon-grid-title"} />
						<h2>{t("recycleBin")}</h2>
					</div>
				</div>
			</div>

			<div className="card-container">
				<div className="content-block pt-2 mx-3 pb-4">
					<ItiTabsComponent
						tabPanelItems={tabPanelItems}
						selectedIndex={tabIndex}
						onSelectedIndexChange={onSelectedIndexChange}
					/>
				</div>
			</div>
		</>
	);
}
